"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

require("core-js/modules/es.function.name");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.regexp.to-string");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.makeNewFormItemConfig = makeNewFormItemConfig;
exports.addVariableFormChild = addVariableFormChild;
exports.makeNewVariableFormChild = makeNewVariableFormChild;
exports.BmVariableFormInfoFactory = exports.BmVariableFormInfo = void 0;

var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/reduce"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createSuper"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/toConsumableArray"));

var _slice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/slice"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _createForOfIteratorHelper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createForOfIteratorHelper"));

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/json/stringify"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectSpread2"));

var _isArray = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/array/is-array"));

var _formDefaultEngine = require("../form-default-engine");

var _bmFormValues = require("../../bm-form-values");

var _bmFormEvents = require("../../bm-form-events");

var _formFactory = require("../form-engine/form-factory");

var _renderVariableLayout = require("../../layouts/render-variable-layout");

var _rules = require("../../../rules");

var _dependencyMap = require("../../dependency-map");

var _utils = require("../../../../utils");

function normalizeExistingReadonlyOpts(c) {
  if (!c) return null;

  if (c === true) {
    return {};
  }

  if ((0, _isArray.default)(c)) {
    return {
      columns: c
    };
  }

  return c;
}

function makeNewFormItemConfig(name, items) {
  return {
    name: name,
    type: 'form',
    options: {
      items: (0, _objectSpread2.default)({}, items)
    }
  };
}

var rowCountUnique = 0;

function addVariableFormChild(value, prohibitEditingExisting, readonlyRows, parent, itemsConfig, layoutConfig) {
  var rowFormInfo = makeNewVariableFormChild(itemsConfig, parent, layoutConfig, value);

  if (prohibitEditingExisting) {
    var existsOperation = prohibitEditingExisting.exists;
    var exists = !existsOperation;

    if (existsOperation) {
      var r = function r(_ref) {
        var fieldIdentifier = _ref.fieldIdentifier;
        return (0, _dependencyMap.resolveField)(rowFormInfo, fieldIdentifier);
      };

      exists = (0, _rules.evaluate)(existsOperation, r);
    }

    if (exists) {
      var readonlyColumns = (prohibitEditingExisting === null || prohibitEditingExisting === void 0 ? void 0 : prohibitEditingExisting.columns) || (0, _keys.default)(rowFormInfo.options.items);
      rowFormInfo = setReadonlyColumns(rowFormInfo, readonlyColumns);
      readonlyRows.push(rowFormInfo.name);
    }
  }

  return rowFormInfo;
}

function makeNewVariableFormChild(items, parent, layout, values) {
  rowCountUnique++;
  items = JSON.parse((0, _stringify.default)(items));
  layout = JSON.parse((0, _stringify.default)(layout));
  return (0, _formDefaultEngine.bmFormInfoFactory)(makeNewFormItemConfig(rowCountUnique.toString(), items), parent, layout, values);
}

function setReadonlyColumns(row, readonlyCols) {
  var setReadonlyFields = [];

  var _iterator = (0, _createForOfIteratorHelper2.default)(readonlyCols),
      _step;

  try {
    var _loop = function _loop() {
      var _context;

      var itemName = _step.value;
      var item = row.options.items[itemName];
      var fields = (0, _map.default)(_context = (0, _bmFormValues.valuedFields)(item, false)).call(_context, function (fqn) {
        var rowRootIdx = item.fullyResolvedName.length - item.name.length;
        return (0, _slice.default)(fqn).call(fqn, rowRootIdx);
      });
      setReadonlyFields.push.apply(setReadonlyFields, (0, _toConsumableArray2.default)(fields));
    };

    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      _loop();
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  var setReadonly = {
    propPath: 'readonly',
    value: true
  };
  return (0, _bmFormEvents.applyChanges)(row, setReadonlyFields, setReadonly);
}

var BmVariableFormInfo = /*#__PURE__*/function (_bmValuedArray) {
  (0, _inherits2.default)(BmVariableFormInfo, _bmValuedArray);

  var _super = (0, _createSuper2.default)(BmVariableFormInfo);

  function BmVariableFormInfo(info, parent, layoutInfo, values) {
    var _this;

    (0, _classCallCheck2.default)(this, BmVariableFormInfo);
    _this = _super.call(this, info, parent);
    _this.type = 'variable-form';
    _this.config = void 0;
    _this.options = void 0;
    _this.layout = void 0;
    _this.previouslyDisabled = false;
    _this.disabled = false;
    _this.previouslyReadonly = false;
    _this.readonly = false;
    _this.hideErrors = false;
    _this.previousHideErrors = null;
    layoutInfo.formLayout = (0, _renderVariableLayout.normalizeFormLayout)(layoutInfo.formLayout);
    var childItemsConfig = info.options.items;
    var childLayoutConfig = layoutInfo.formLayout;
    _this.config = {
      items: childItemsConfig,
      formLayout: childLayoutConfig
    };
    var order = [];
    var prohibitEditingExisting = normalizeExistingReadonlyOpts(info.options.prohibitEditingExisting);
    var readonlyRows = [];
    values = values || [];
    var items = {};

    var _iterator2 = (0, _createForOfIteratorHelper2.default)(values),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var value = _step2.value;
        var row = addVariableFormChild(value, prohibitEditingExisting, readonlyRows, (0, _assertThisInitialized2.default)(_this), _this.config.items, _this.config.formLayout.$each.default);
        items[row.name] = row;
        order.push(row.name);
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }

    _this.options = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, info.options), {}, {
      items: items
    });
    _this.layout = layoutInfo;
    _this.layout.options.order = order;
    _this.layout.options.hideRemove = (0, _reduce.default)(readonlyRows).call(readonlyRows, function (a, c) {
      a[c] = true;
      return a;
    }, {});

    if ((0, _utils.isEmptyObj)(items)) {
      var emptyRow = addVariableFormChild({}, normalizeExistingReadonlyOpts(false), readonlyRows, (0, _assertThisInitialized2.default)(_this), _this.config.items, _this.config.formLayout.$each.default);
      items[emptyRow.name] = emptyRow;
      order.push(emptyRow.name);
    }

    return _this;
  }

  return BmVariableFormInfo;
}((0, _bmFormValues.bmValuedArray)(_formFactory.BmFormInfo));

exports.BmVariableFormInfo = BmVariableFormInfo;

var BmVariableFormInfoFactory = function BmVariableFormInfoFactory(info, parent, layout, values) {
  return new BmVariableFormInfo(info, parent, layout, values);
};

exports.BmVariableFormInfoFactory = BmVariableFormInfoFactory;
